import api from './api/apiClient';

/**
 * 대시보드 통계 타입 정의
 */
export interface DashboardStats {
  registered_users: number;
  monthly_transactions: number;
  pending_approvals: number;
  low_stock_alerts: number;
}

/**
 * 대시보드 활동 아이템 타입 정의
 */
export interface DashboardActivity {
  id: string;
  type?: string;
  title: string;
  message: string;
  created_at: string;
  reference_type?: string;
  /** 참조 대상 PK — reference_url 이 없는 과거 알림의 이동 경로 유도에 사용 */
  reference_id?: string;
  reference_url?: string;
  metadata?: Record<string, any>;
  is_read?: boolean;
}

/**
 * 대시보드 API 응답 타입
 */
interface DashboardStatsResponse {
  success: boolean;
  data: DashboardStats;
  error?: string;
}

/**
 * 대시보드 활동 API 응답 타입
 */
interface DashboardActivitiesResponse {
  success: boolean;
  data: DashboardActivity[];
  error?: string;
}

/**
 * 대시보드 서비스
 * 백엔드 /api/dashboard API와 통신하여 통계 데이터를 가져옵니다
 */
class DashboardService {
  private baseUrl = '/dashboard';

  /**
   * 대시보드 종합 통계 조회
   *
   * 반환 데이터:
   * - registered_users: 등록된 사용자 수 (해당 회사)
   * - monthly_transactions: 금월 트랜잭션 수 (매출 + 구매 주문)
   * - pending_approvals: 대기 중인 승인 건수 (모든 주문 타입)
   * - low_stock_alerts: 재고 부족 알림 수 (안전 재고 미만)
   */
  async getStats(): Promise<DashboardStats> {
    try {
      const response = await api.get<DashboardStatsResponse>(
        `${this.baseUrl}/stats`
      );

      return response.data;
    } catch (error) {
      console.error('대시보드 통계 조회 실패:', error);
      return {
        registered_users: 0,
        monthly_transactions: 0,
        pending_approvals: 0,
        low_stock_alerts: 0
      };
    }
  }

  /**
   * 최근 활동 피드 조회
   *
   * @param limit - 조회할 활동 개수 (기본: 10)
   * @returns 최근 활동 목록
   */
  async getActivities(limit: number = 10): Promise<DashboardActivity[]> {
    try {
      const response = await api.get<DashboardActivitiesResponse>(
        `${this.baseUrl}/activities?limit=${limit}`
      );

      return response.data;
    } catch (error) {
      console.error('대시보드 활동 조회 실패:', error);
      return [];
    }
  }
}

export default new DashboardService();
